import script from "./ChatMessageReactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageReactions.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessageReactions.vue?vue&type=style&index=0&id=7dfcb267&lang=scss"

const __exports__ = script;

export default __exports__